import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  headers: { 'Content-Type': 'application/json' },
});

// Attach token on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-refresh on 401
api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const original = err.config;
    if (err.response?.status === 401 && !original._retry) {
      original._retry = true;
      const refresh = localStorage.getItem('refresh_token');
      if (refresh) {
        try {
          const { data } = await axios.post('/api/auth/refresh/', { refresh });
          localStorage.setItem('access_token', data.access);
          original.headers.Authorization = `Bearer ${data.access}`;
          return api(original);
        } catch {
          localStorage.clear();
          window.location.href = '/login';
        }
      } else {
        localStorage.clear();
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;

// ── Auth ─────────────────────────────────────────────────────────
export const authService = {
  login: (data) => api.post('/auth/login/', data),
};

// ── Employees ────────────────────────────────────────────────────
export const employeeService = {
  list:   (params) => api.get('/employees/', { params }),
  get:    (id)     => api.get(`/employees/${id}/`),
  create: (data)   => api.post('/employees/', data),
  update: (id, d)  => api.put(`/employees/${id}/`, d),
  delete: (id)     => api.delete(`/employees/${id}/`),
  stats:  ()       => api.get('/employees/stats/'),
};

// ── Salaries ─────────────────────────────────────────────────────
export const salaryService = {
  list:    (params)     => api.get('/salaries/', { params }),
  months:  ()           => api.get('/salaries/months/'),
  summary: (month)      => api.get('/salaries/summary/', { params: { month } }),
  uploadExcel: (fd)     => api.post('/salaries/upload-excel/', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  uploadLogs: (params)  => api.get('/upload-logs/', { params }),
};

// ── Dashboard ────────────────────────────────────────────────────
export const dashboardService = {
  stats: () => api.get('/dashboard/stats/'),
};
